import { render, staticRenderFns } from "./trsPrivacyPolicy.vue?vue&type=template&id=92571e2c&scoped=true"
import script from "./trsPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./trsPrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./trsPrivacyPolicy.vue?vue&type=style&index=0&id=92571e2c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92571e2c",
  null
  
)

export default component.exports